// extracted by mini-css-extract-plugin
export var container = "SmallCard-module--container--sVXSA";